import React, { useState } from 'react';
import { Card, DatePicker, Button, Table, Spin } from 'antd';
import moment from 'moment';
import 'moment/locale/pt-br';
import EvolutionChart from '../evolutionChart/EvolutionChart';
import TotalEvolutionChart from '../totalEvolutionChart/TotalEvolutionChart';
import ProfitExpenseChart from '../profitExpenseChart/ProfitExpenseChart';
import { reportRequests } from '../../requests';
import { toCurrency } from '../../utils/format';

const { RangePicker } = DatePicker;




const ReportPage = () => {
  const [period, setPeriod] = useState([null, null]);
  const [loading, setLoading] = useState(false);
  const [aggregatedData, setAggregatedData] = useState([]);

  // Desabilita meses anteriores a 2025 e meses posteriores ao mês atual
  const disabledDate = (current) => {
    if (!current) return false;
    const lowerLimit = moment('2024-01', 'YYYY-MM');
    const upperLimit = moment({ year: moment().year() + 1, month: 11, day: 1 }); // December of currentYear+1
    return current.isBefore(lowerLimit, 'month') || current.isAfter(upperLimit, 'month');
  };


  const handlePeriodChange = (dates) => {
    if (dates) {
      setPeriod(dates);
    } else {
      setPeriod([null, null]);
    }
  };

  const fetchAggregatedData = async () => {
    if (period[0] && period[1]) {
      setLoading(true);

      console.log(period[0].month(), period[0].year(), period[1].month(), period[1].year());

      reportRequests.getByPeriod(period[0].month() + 1, period[0].year(), period[1].month() + 1, period[1].year()).then(response => {
        const responseList = response.data;
//        responseList.sort((a, b) => moment(a.date, 'MM/YYYY') - moment(b.date, 'MM/YYYY'));
        console.log('responseList ', responseList);
        setAggregatedData(responseList);
        setLoading(false);
      }).catch(err => {
        console.log(err);
        setAggregatedData([]);
        setLoading(false);
      });
    }
  };

  const columnsMonth = [
    {
      title: 'Mês',
      dataIndex: 'date',
      key: 'date',
      sorter: (a, b) => a.date.localeCompare(b.date),
    },
    {
      title: 'Disparos',
      dataIndex: 'sends',
      key: 'sends',
      sorter: (a, b) => a.sends - b.sends,
      render: (value) => toCurrency(value),
    },
    {
      title: 'MarketStories',
      dataIndex: 'marketStories',
      key: 'marketStories',
      sorter: (a, b) => a.marketStories - b.marketStories,
      render: (value) => toCurrency(value),
    },
    {
      title: 'Tyra',
      dataIndex: 'tyra',
      key: 'tyra',
      sorter: (a, b) => a.tyra - b.tyra,
      render: (value) => toCurrency(value),
    },
    {
      title: 'Total receitas',
      dataIndex: 'revenues',
      key: 'revenues',
      sorter: (a, b) => a.revenues - b.revenues,
      render: (value) => toCurrency(value),
    },
    {
      title: 'Total despesas',
      dataIndex: 'expenses',
      key: 'expenses',
      sorter: (a, b) => a.expenses - b.expenses,
      render: (value) => toCurrency(value),
    },
    {
      title: 'Lucro',
      dataIndex: 'profit',
      key: 'profit',
      sorter: (a, b) => a.profit - b.profit,
      render: (value) => toCurrency(value),
    },
  ];


  const balanceLines = [
    { dataKey: 'revenues', name: 'Receitas', stroke: '#4CAF50' },
    { dataKey: 'expenses', name: 'Despesas', stroke: '#F44336' },
  ];

  const profitLines = [
    { dataKey: 'profit', name: 'Lucro realizado', stroke: '#4CAF50' },
    { dataKey: 'profitProjection', name: 'Lucro projetado', stroke: '#2196F3' },
  ];

  const revenuesLines = [
    { dataKey: 'revenues', name: 'Despesa realizada', stroke: '#4CAF50' },
    { dataKey: 'revenuesProjection', name: 'Despesa projetada', stroke: '#2196F3' },
  ];

  const expensesLines = [
    { dataKey: 'expenses', name: 'Despesa realizada', stroke: '#F44336' },
    { dataKey: 'expensesProjection', name: 'Despesa projetada', stroke: '#2196F3' },
  ];


  const categoryLines = [
    { dataKey: 'sends', name: 'Disparos', stroke: '#4CAF50' },
    { dataKey: 'tyra', name: 'Tyra', stroke: '#2196F3' },
    { dataKey: 'marketStories', name: 'MarketStories', stroke: '#F44336' },
  ];

  return (
    <div style={{ margin: '20px 10px' }}>
      <div style={{ marginBottom: 16 }}>
        <RangePicker
          picker="month"
          value={period}
          onChange={handlePeriodChange}
          format="MM/YYYY"
          disabledDate={disabledDate}
        />
        <Button
          type="primary"
          onClick={fetchAggregatedData}
          disabled={!period[0] || !period[1]}
          style={{ marginLeft: 16 }}
        >
          Gerar Relatório
        </Button>
      </div>
      <Spin spinning={loading} tip="Carregando dados...">

        {aggregatedData.length > 0 && (
          <div style={{ marginTop: 80 }}>
            <h3 style={{ textAlign: 'center' }}>Receitas x Despesas</h3>
            <EvolutionChart aggregatedData={aggregatedData} lines={balanceLines} />
          </div>
        )}

        {aggregatedData.length > 0 && (
          <div style={{ marginTop: 80 }}>
            <h3 style={{ textAlign: 'center' }}>Lucro realizado x Lucro projetado</h3>
            <EvolutionChart aggregatedData={aggregatedData} lines={profitLines} />
          </div>
        )}

        {aggregatedData.length > 0 && (
          <div style={{ marginTop: 80 }}>
            <h3 style={{ textAlign: 'center' }}>Receita realizada x Receita projetada</h3>
            <EvolutionChart aggregatedData={aggregatedData} lines={revenuesLines} />
          </div>
        )}

        {aggregatedData.length > 0 && (
          <div style={{ marginTop: 80 }}>
            <h3 style={{ textAlign: 'center' }}>Despesa realizada x Despesa projetada</h3>
            <EvolutionChart aggregatedData={aggregatedData} lines={expensesLines} />
          </div>
        )}

        {aggregatedData.length > 0 && (
          <div style={{ marginTop: 80 }}>
            <h3 style={{ textAlign: 'center' }}>Receitas por tipo</h3>
            <EvolutionChart aggregatedData={aggregatedData} lines={categoryLines} />
          </div>
        )}

        <div style={{ marginTop: 80 }}>
          <h3 style={{ textAlign: 'center' }}>Extrato por mês</h3>
          <Table
            dataSource={aggregatedData}
            columns={columnsMonth}
            rowKey="date"
            pagination={false}
            locale={{ emptyText: 'Nenhum dado encontrado para o período selecionado' }}
          />
        </div>
      </Spin>
    </div>
  );
};

export default ReportPage;